export const DEFAULT_STATE = {
  customNotificationData: {},
  latestNotificationData: {},
};
